import { render } from "./Places.vue?vue&type=template&id=a0fd57c0"
import script from "./Places.vue?vue&type=script&lang=js"
export * from "./Places.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__